import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";
import Converter from "../../containers/ConverterContainer";
import Toolbar from "../../containers/ToolBarContainer";
import "../../styles/ContainerCommon.css";
import { ConvertTypes } from "../../Utilities/converterparamscnf.js";
import { ConvertTypesOut } from "../../Utilities/converterparamscnf.js";
import { Label } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Typography } from "@mui/material";

import { Button, Menu, MenuItem } from "@mui/material";

export default class ConvertersPool extends Component {
  constructor() {
    super();
    this.UpdateCurrentDragging = this.UpdateCurrentDragging.bind(this);
  }
  state = {
    currentDragging: "",
    anchorEl: false,
  };

  UpdateCurrentDragging(name) {
    const { setDraggedConverter } = this.props;
    this.setState({ currentDragging: name });
    setDraggedConverter(name);
  }

  handleShowConvertersmanager = () => {
    document.getElementById("ToolbarManagerContainer").style.display = "";
    let convertermanager = document.getElementById("convertermanager");
    convertermanager.style.width = "500px";
    convertermanager.style.visibility = "hidden";

    let op = 0.1;
    let timer = setInterval(fadeIn, 5);
    function fadeIn() {
      convertermanager.style.visibility = "visible";
      if (op >= 0.95) {
        clearInterval(timer);
      }
      convertermanager.style.opacity = op;
      op += op * 0.5;
    }
  };

  handleAdd = (newconvertertype) => {
    const { addConverter, converters } = this.props;

    let newid = "converter1";

    for (let ndx = 1; ndx < 100; ndx++) {
      newid = "converter" + ndx;
      if (converters.findIndex((converter) => converter.id === newid) < 0) break;
    }
    ///////////////////////////////////////////////////////////////////
    const typeInOut = this.props.typeInOut;
    let mytypeOrigin, mytypeDestination, mytypeInOut;
    if (typeInOut === "In") {
      // mytypeOriginnewconvertertype = "aama_astm"; //default type
      mytypeOrigin = newconvertertype;
      mytypeDestination = "mdl";
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    } else if (typeInOut === "Out") {
      mytypeOrigin = "mdl";
      mytypeDestination = "mdl_V7"; //default type
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    }
  };
  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  handleCopy = () => {
    const { copyConverter, converters } = this.props;
    const { currentDragging } = this.state;

    const index = converters.findIndex((converter) => converter.id === currentDragging);
    if (index >= 0) {
      const type = converters[index].type;
      const typeDestination = converters[index].typeDestination;
      const typeInOut = converters[index].typeInOut;
      copyConverter({ id: currentDragging, type, typeDestination, typeInOut });
    }
  };

  handleRemove = () => {
    const { removeConverter } = this.props;
    const { currentDragging } = this.state;
    if (window.confirm(currentLocals(this.props.locale).converter.sure_to_delete + currentDragging.toUpperCase())) {
      removeConverter({ id: currentDragging });
    }
  };

  handleOpenMenu = (event) => {
    //if In, display Accumark and AAMA/ASTM; else create a converter "Out"  mdl
    if (this.props.typeInOut === "In") this.setState({ anchorEl: event.currentTarget });
    else this.handleAdd("mdl_V7"); //It is "Out", so mdl will be created
  };
  handleClickMenu = () => {
    this.setState({ anchorEl: 0 });
  };
  handleCloseMenu = () => {
    this.setState({ anchorEl: 0 });
  };
  render() {
    //alert("Configure ConverterPool");
    const { converters } = this.props; //accesssing  a property stored in store
    const typeInOut = this.props.typeInOut; //Parameter, passed in ConvertersPool calling in Main.js
    const commands = [
      {
        label: "cmdAddTile",
        command: this.handleAdd,
      },
    ];
    let converterIn = [];
    let converterOut = [];
    let converterTitleToShow = [];
    let converterToShow = [];

    for (let i = 0; i < converters.length; i++) {
      var currentConverter = converters[i];
      if (
        currentConverter.type === "accumark" ||
        currentConverter.type === "aama_astm" ||
        currentConverter.typeInOut === "In"
      ) {
        //Solo pondremos converters si forman parte de los autorizadso pro la ssubscripción
        if (ConvertTypes.indexOf(currentConverter.type) >= 0) converterIn.push(currentConverter);
      } else if (currentConverter.type === "mdl" || currentConverter.typeInOut === "Out") {
        //Solo pondremos converters si forman parte de los autorizadso pro la ssubscripción
        if (ConvertTypesOut.indexOf(currentConverter.typeDestination) >= 0) converterOut.push(currentConverter);
      }
    }

    /*   let convertersIn = converters.filter(
      converter => (converter.typeout === "mdl" )
    );
    let convertersOut = converters.filter(
      converter => (converter.typeout !== "mdl" )
    );*/
    //var page = "  &#128459; ";
    var page = "  \u{1F5CB}  ";
    var arrow = "  \u{1F8A7}  ";
    if (this.props.typeInOut === "In") {
      converterToShow = converterIn;
      converterTitleToShow =
        /*page +arrow +"MDL" +". " +*/
        currentLocals(this.props.locale).converter.ConversionIn;
    }
    if (this.props.typeInOut === "Out") {
      converterToShow = converterOut;
      converterTitleToShow =
        /*"MDL" +   arrow +  page +". " +*/
        currentLocals(this.props.locale).converter.ConversionOut;
    }
    let displayCRUD = this.props.enableCRUD ? "block" : "none";

    const open = Boolean(this.state.anchorEl);
    const renderMenuAddAconverter = () => {
      if (this.props.typeInOut == "In")
        return (
          <div>
            <MenuItem
              onClick={() => {
                this.handleAdd("accumark");
                this.handleCloseMenu();
              }}
            >
              Accumark
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.handleAdd("aama_astm");
                this.handleCloseMenu();
              }}
            >
              AAMA/ASTM
            </MenuItem>
          </div>
        );
      else if (this.props.typeInOut == "Out") return <div></div>;
    };

    let displayConvertersBodyEmpty;
    if (converterToShow.length > 0) displayConvertersBodyEmpty = "none";
    else displayConvertersBodyEmpty = "block";

    return (
      <div className="ConverterPool">
        <div className="ConverterPoolTitleAndMenu_00">
          <div style={{ float: "left", display: "inline-block" }}>
            <Typography sx={{ marginLeft: 2, color: "primary.main" }} variant="h4">
              {converterTitleToShow}
            </Typography>
          </div>
          <div style={{ float: "right", display: displayCRUD, padding: "16px", paddingBottom: "0px" }}>
            <Button
              id="ButtonAddConverter"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => {
                this.handleOpenMenu(event);
              }}
              endIcon={this.props.typeInOut === "In" ? open ? <ExpandLessIcon /> : <ExpandMoreIcon /> : ""}
            >
              {currentLocals(this.props.locale).converter.AddConverter}
            </Button>
            <Menu
              id="MenuAddConverter"
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={() => {
                this.handleCloseMenu();
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {renderMenuAddAconverter()}
            </Menu>
          </div>
        </div>

        <div
          id={`ConverterPool${this.props.typeInOut}`}
          className="ConverterPoolInOut"
          data-tut="reactour__converterspool"
        >
          <div
            className="results-body ConvertersBodyEmpty"
            id="convertersbodyEmpty"
            style={{ display: displayConvertersBodyEmpty }}
          >
            <div className="ConvertersBodyEmpty image"></div>
            <div className="ConvertersBodyEmpty Title">
              {this.props.typeInOut === "In"
                ? currentLocals(this.props.locale).converter.NoConverterToMDL
                : currentLocals(this.props.locale).converter.NoConverterFromMDL}
            </div>
            <div className="ConvertersBodyEmpty Description">
              {this.props.typeInOut === "In"
                ? currentLocals(this.props.locale).converter.ChooseAnInputFormat
                : currentLocals(this.props.locale).converter.ChooseAnOutputFormat}
            </div>
          </div>

          <div className="containerConverter " id="myconverters">
            {converterToShow.map((converter) => (
              <Converter
                OnDragging={this.UpdateCurrentDragging}
                convertertype={converter.type}
                convertertypedestination={converter.typeDestination}
                converterId={converter.id}
                key={converter.id}
                typeInOut={this.props.typeInOut}
              ></Converter>
            ))}

            <div className="containerAddButton" id="AddButton" style={{ textAlign: "center", display: "none" }}>
              <Toolbar
                commands={commands}
                InTile={true}
                TextAddButtonTile={currentLocals(this.props.locale).converter.AddConverter}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
